import * as React from 'react';

import { IActionContext } from '@msdyn365-commerce/core';
import { IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { BackInStockSubscriptionModal } from './Klaviyo/back-in-stock-subscription-modal';
import { UncontrolledTooltip } from '@msdyn365-commerce-modules/utilities';

import classnames from 'classnames';

const KlaviyoBackInStockSubscription = ({
    context,
    product,
    productAvailableQuantity
}: {
    context: IActionContext;
    product?: SimpleProduct;
    productAvailableQuantity?: IProductInventoryInformation;
}) => {
    const [backInStockModalOpen, setBackInStockModalOpen] = React.useState(false);
    const btnRef = React.createRef<HTMLButtonElement>();

    const publicKey = context.requestContext.app.config.heiKlaviyoPublicKey;
    if (
        !publicKey ||
        !product ||
        !productAvailableQuantity ||
        productAvailableQuantity.StockLevelCode?.toUpperCase() === 'INSTOCK' ||
        productAvailableQuantity.StockLevelCode?.toUpperCase() === 'LOW'
    ) {
        process.env.NODE_ENV === 'development' &&
            console.log('KlaviyoSubscription', product?.ItemId, productAvailableQuantity?.StockLevelCode);
        return null;
    }

    const label = 'Notify when back in stock';

    return (
        <div
            className={classnames('hei-klaviyo-subscription klaviyo-instock')}
            onClick={() => {
                setBackInStockModalOpen(true);
            }}
        >
            <button className='msc-btn' type='button' aria-label={label} placeholder='Email' ref={btnRef} />
            <UncontrolledTooltip trigger='hover focus' target={btnRef}>
                {label}
            </UncontrolledTooltip>
            <BackInStockSubscriptionModal
                context={context}
                product={product}
                className='hei-back-in-stock-modal'
                modalOpen={backInStockModalOpen}
                setModalOpen={v => setBackInStockModalOpen(v)}
            />
        </div>
    );
};

export { KlaviyoBackInStockSubscription };
